// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1qa5a","label":"Radio_label__3p7-5","checkMark":"Radio_checkMark__19SOS","disabled":"Radio_disabled__2tGyy"};